import type { BreakoutPluginOptions } from '@atlaskit/editor-plugin-breakout/breakoutPluginType';

export function breakoutPluginOptions(): BreakoutPluginOptions {
	return {
		allowBreakoutButton: true,
	};
}
